class InactiveItem {
    constructor(dataItem) {
        this.dataItem = dataItem;
        this.callbacks = [];
    }
    onActivate(callback) {
        return new Promise((resolve) => {
            this.callbacks.push({
                callback,
                resolve
            });
        });
    }
    activate() {
        const callbacks = this.callbacks;
        let item;
        for (let idx = 0; idx < callbacks.length; idx++) {
            item = this.callbacks[idx];
            item.callback(this.dataItem);
            item.resolve();
        }
        this.callbacks = [];
    }
}
class InactiveItemsCollection {
    constructor() {
        this.items = {};
    }
    add(items) {
        for (let idx = 0; idx < items.length; idx++) {
            this.items[items[idx].uid] = new InactiveItem(items[idx]);
        }
    }
    forEach(callback) {
        for (const uid in this.items) {
            if (Object.prototype.hasOwnProperty.call(this.items, uid)) {
                callback(this.items[uid]);
            }
        }
    }
    getByUid(uid) {
        return this.items[uid];
    }
    remove(item) {
        delete this.items[item.uid];
    }
    destroy() {
        this.items = {};
    }
}

export { InactiveItem, InactiveItemsCollection };
